import { IPosition } from "../../../meta/Drag/CsiDragController";
import { GeometryTypes } from "../enumerations/GeometryTypes";
import { ShapeType } from "../enumerations/ShapeType";
import { IPolarAdjustHandle } from "./PolarAdjustHandle";
import { IShapeGuide } from "./ShapeGuide";
import { IShapePath } from "./ShapePath";
import { IShapeTextRectangle } from "./ShapeTextRectangle";
import { IXYAdjustHandle } from "./XYAdjustHandle";

/**
 * Union type of IPolarAdjustHandle and IXYAdjustHandle
 */
type handleType = IPolarAdjustHandle | IXYAdjustHandle;

export const enum HandleType {
    STRAIGHT="straight",
    MIRRORED="mirrored",
    ASYMMETRIC="asymmetric",
    DISCONNECTED="disconnected"
}

export interface IHandlePoint {
    frontHandle?: IPosition;
    backHandle?: IPosition;
    frontToBackRatio?: number;
    type: HandleType;
}

/**
 * Abstract Geometry interface
 * Holds geometry type
 */
export interface IAbstractGeometry<T> {
    type: T;

    /** List of Shape Adjust Values */
    avList?: IShapeGuide[];

    /** List of Shape Guides */
    gdLst?: IShapeGuide[];

    /** List of Shape Adjust Handles */
    ahLst?: handleType[];

    // FIXME: retain, if this is required; else omit.
    // List of Shape Connection Sites
    // cxnLst: any[];

    /** Shape Text Rectangle */
    rect?: IShapeTextRectangle;

    /** List of Shape Paths */
    pathLst?: IShapePath[];
}

/**
 * This element specifies the existence of a custom geometric shape.
 * This shape consists of a series of lines and curves described within a
 * creation path. In addition to this there can also be adjust values, guides,
 * adjust handles, connection sites and an inscribed rectangle specified for
 * this custom geometric shape.
 *
 * REF: ECMA-376, Third Edition, Part 1 | Section: 20.1.9.8
 */
export interface ICustomGeometry extends IAbstractGeometry<GeometryTypes.CUSTOM> {
    /** List of Shape Paths. Make it mandatory. */
    pathLst: IShapePath[];

    /** Whether or not the shape should be constructed of straight lines */
    lineShape?: boolean;

    /**
     * Specifies the preset geometry that is used for this shape. This preset
     * can have any of the values in the enumerated list for ShapeType. This
     * attribute is required in order for a preset geometry to be rendered.
     */
    presetShape?: ShapeType;
}

export interface IPenGeometry extends IAbstractGeometry<GeometryTypes.PEN> {
    /** List of Shape Paths. Make it mandatory. */
    pathLst: IShapePath[];

    /** List of handle points for the shape */
    handlePoints: IHandlePoint[];

    /** Whether or not the shape should be constructed of straight lines */
    lineShape?: boolean;

    /**
     * Specifies the preset geometry that is used for this shape. This preset
     * can have any of the values in the enumerated list for ShapeType. This
     * attribute is required in order for a preset geometry to be rendered.
     */
    presetShape?: ShapeType;
}